import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, PageEmptyState, useDevice } from 'seagull';
import { Plus } from 'seagull/icons';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServiceTemplateType } from '~/models/service-template';
import { selectors } from '~/store/state-selectors';
import { CommonServicesPage } from '../CommonServicesPage/CommonServicesPage';
import { ColumnId, bulkImportRoute } from '../CommonServicesPage/CommonServicesPage.utils';
import { useExportCsv } from '../CommonServicesPage/useExportCsv';
import EmptyServices from '../emptyServices.svg';
import ServiceLibrarySeeWhatItsLike from './SeeWhatItsLike/SeeWhatItsLike';
export const importServicesRoute = bulkImportRoute('services');
export function ServicesPage() {
    const { t: texts } = useLocaleKeys('pages.servicesPage');
    const tableDefs = [
        {
            headerItem: {
                value: texts.columnHeaders.serviceName(),
                id: ColumnId.Name
            },
            columnDef: {
                width: [
                    200,
                    400
                ],
                sortable: true,
                mobile: {},
                bi: {
                    name: 'sort_services_by_name'
                }
            },
            defaultSortDirection: 'desc'
        },
        {
            headerItem: {
                value: texts.columnHeaders.rate(),
                id: ColumnId.Rate
            },
            columnDef: {
                width: 130,
                sortable: true,
                mobile: {},
                bi: {
                    name: 'sort_services_by_rate'
                }
            },
            defaultSortDirection: 'asc'
        },
        {
            headerItem: {
                value: texts.columnHeaders.billingOccurrence(),
                id: ColumnId.BillingOccurance
            },
            columnDef: {
                width: 120,
                sortable: true,
                mobile: {},
                bi: {
                    name: 'sort_services_by_billing_occurrence'
                }
            },
            defaultSortDirection: 'desc'
        },
        {
            headerItem: {
                value: texts.columnHeaders.billingTrigger(),
                id: ColumnId.BillingTrigger
            },
            columnDef: {
                width: 110,
                sortable: true,
                bi: {
                    name: 'sort_services_by_billing_trigger'
                }
            },
            defaultSortDirection: 'desc'
        }
    ];
    const baseColumnDefs = tableDefs.map((d)=>d.columnDef);
    const baseHeaderItems = tableDefs.map((d)=>d.headerItem);
    const mobileSortOptions = tableDefs.flatMap((d, colIndex)=>d.columnDef.sortable && d.columnDef.mobile ? [
            {
                id: d.headerItem.id,
                label: d.headerItem.value,
                defaultDirection: d.defaultSortDirection,
                colIndex
            }
        ] : []);
    const importServicesLink = useStore(selectors.filterAvailableRoutes([
        importServicesRoute
    ]))[0];
    const { isMobileDevice } = useDevice();
    const { exportingCsv, handleExportCsv } = useExportCsv('service', 'services-', 'services-page-export-csv-error');
    function renderEmptyState(param) {
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsx(PageEmptyState, {
            maxHeight: true,
            testId: "services-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyServices, {}),
            title: texts.emptyTitle(),
            message: texts.emptyMessage(),
            actions: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !isMobileDevice && /*#__PURE__*/ _jsx(ServiceLibrarySeeWhatItsLike, {}),
                    /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'create_service_from_empty_state'
                        },
                        testId: "service-library-new-btn",
                        onClick: ()=>openBuilder(),
                        children: texts.createService()
                    })
                ]
            })
        });
    }
    function renderHeaderActions(param) {
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                importServicesLink && /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'import_services'
                    },
                    skin: "primaryOutline",
                    as: Link,
                    to: importServicesLink.url,
                    children: importServicesLink.text
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'export_services_csv'
                    },
                    skin: "primaryOutline",
                    testId: "services-page-export-csv-btn",
                    disabled: exportingCsv,
                    onClick: handleExportCsv,
                    children: texts.exportCsv()
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'create_service'
                    },
                    prefixIcon: /*#__PURE__*/ _jsx(Plus, {
                        size: 18
                    }),
                    testId: "service-library-new-btn",
                    onClick: ()=>openBuilder(),
                    children: texts.newService()
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(CommonServicesPage, {
        title: texts.title(),
        subtitle: texts.subtitle(),
        columnDefs: baseColumnDefs,
        headerItems: baseHeaderItems,
        templateType: ServiceTemplateType.Service,
        renderEmptyState: renderEmptyState,
        headerActions: renderHeaderActions,
        mobileSortOptions: mobileSortOptions
    });
}
